import React from 'react';

const ContinueButton = ({ label, isDisabled, onClick }) => {
  return (
    <button
      type="button"
      className={`flex justify-center cursor-pointer items-center self-center w-full sm:w-[432px] h-14 p-5 mt-14
        rounded-[13px] text-center text-base font-medium ${
          isDisabled ? "bg-[#c4c4c4] text-white" : "bg-[#eaf524] text-black"
        }`}
      aria-label="Continue to profile"
      disabled={isDisabled}
      onClick={onClick}
    >
      {label || "Continue"}
    </button>
  );
};

export default ContinueButton;
